import Sheet from './components/PromotionSheet';
import GlobalStyles from '@uda/bento-components/lib/themes/global';
import { developmentProcessed } from './mock/development';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
// import { IntlProvider, useIntl } from "react-intl";
import styled, { ThemeProvider } from 'styled-components';
import { useState, useEffect } from 'react';
import defaultTheme from './themes/defaultTheme';
import routes from './config/routes';
import { AssetReport } from './pages/assetReport/assetReport.page';
import { AssetReportDev } from './pages/assetReport/assetReportDev.page';
import I18nProvider from './i18n/i18n';
import { handlePDFGeneration } from './helpers/pdfDownload';

export const AppStyle = styled.div`
  width: 100vw;
  height: 100vh;
  box-sizing: border-box;
`;

function App() {
  const width = 1654;
  const height = 1170;
  const developmentData = developmentProcessed;
  const [theme, setTheme] = useState(defaultTheme);

  return (
    <div
      className="App"
      style={{ width: '100vw', height: '100vh', boxSizing: 'border-box' }}
    >
      <ThemeProvider theme={theme}>
        <I18nProvider>
          <GlobalStyles />
          <BrowserRouter>
            <Routes>
              <Route
                path={routes.pages.DESKTOP_SHEET}
                element={
                  <Sheet
                    pageWidth={width}
                    pageHeight={height - 1}
                    inputData={developmentData}
                  />
                }
              />
              <Route
                path={routes.pages.ASSET_SHEET}
                element={
                  <AssetReport
                    pageWidth={width}
                    pageHeight={height - 1}
                    inputData={developmentData}
                  />
                }
              />
              <Route
                path={routes.pages.ASSET_SHEET_DEV}
                element={<AssetReportDev />}
              />
            </Routes>
          </BrowserRouter>
        </I18nProvider>
      </ThemeProvider>
    </div>
  );
}

export default App;
